import {AbstractQueryBuilder, ExtractSortMap, IQueryMarkers} from '@global-data';

export type IUsersQueryMarkers = IQueryMarkers & {
	includeDisabled: boolean;
	includePermanent: boolean;
	includeTemporary: boolean;
};

export const UsersQuerySortBy = {
	username: 'default',
	name: 'name',
	email: 'email',
	phonenumber: 'phonenumber',
	enabled: 'enabled',
} as const;
export type UsersQuerySortBy = (typeof UsersQuerySortBy)[keyof typeof UsersQuerySortBy] | keyof typeof UsersQuerySortBy;

export class UsersQueryBuilder extends AbstractQueryBuilder<IUsersQueryMarkers, ExtractSortMap<typeof UsersQuerySortBy>> {
	private static readonly defaults: IUsersQueryMarkers = {
		searchText: '',
		sortBy: UsersQuerySortBy.username,
		sortDesc: false,
		includeDisabled: false,
		includePermanent: false,
		includeTemporary: false,
	};

	// Implementation of sortByMap according to the requirements of AbstractQueryBuilder
	protected readonly sortByMap = this.createSortByMap(UsersQuerySortBy);

	public static create(): UsersQueryBuilder {
		return new UsersQueryBuilder();
	}
	private constructor() {
		super(UsersQueryBuilder.defaults);
	}

	public setIncludeDisabled(includeDisabled: boolean): this {
		return this.updateMarkers({includeDisabled});
	}

	public setIncludePermanent(includePermanent: boolean): this {
		return this.updateMarkers({includePermanent});
	}

	public setIncludeTemporary(includeTemporary: boolean): this {
		return this.updateMarkers({includeTemporary});
	}

	protected override buildFixedParts(): string[] {
		return [];
	}
}
